import React from "react";
import styles from "./HelperCommentContentEditor.module.scss";

const HelperCommentContentEditor = ({ comment }) => (
	<div className={styles.container}>
		<p>Module is empty. Go to the Sitecore Content Editor. {comment}</p>
	</div>
);

export default HelperCommentContentEditor;